import { CardHeader, CardFooter, Card, CardImg, CardText, CardBody, Button } from 'reactstrap';
import { useState } from 'react';

const AnimatedMarketItemCard = ({ item, idx }) => {
    
    const { name, colors, sizes, description, price, itemImage } = item;

    let [itemQuantity, setItemQuantity] = useState(0);
    
    const addItem = () => {
        setItemQuantity(++itemQuantity);
    };

    const subItem = () => {
        
        if(itemQuantity <= 0){
            alert('Item quantity cannot be less than 0');
            setItemQuantity(0);
        } else {
            setItemQuantity(--itemQuantity);
        }
    };
    
    return(  
        <Card className='img-thumbnail marketCardDisplay'>
            <CardHeader>{name} {idx}</CardHeader>
            <CardImg 
                src={itemImage} 
                alt={name} 
                style={{ 
                        margin: '1rem auto',
                        maxWidth: '70%',
                        height: 'auto',
                    }} />
            <CardBody style={{ 
                                display: 'flex', 
                                justifyContent:'flex-start', 
                                flexWrap:'wrap', 
                                marginTop: '-4rem' 
                            }}>
                <CardText>
                    <span style={{ fontSize: '1.5rem'}}>
                        {name} 
                    </span>
                    <span style={{ display: 'flex', justifyContent:'flex-end', marginTop: '-2rem'}}>
                        {'$' + price + '.00'} 
                    </span>
                    <p className='marketCardText'>
                        <span>
                            {description}
                        </span>
                    </p>
                    <p className='marketCardText my-4'>
                        Colors: {
                            colors.map((color) => {
                                return(<span style={{ 
                                                        backgroundColor: color, 
                                                        padding: '0.3rem 1rem',
                                                        margin: '0.5rem',
                                                        borderRadius: '1rem'
                                                    }}>
                                       </span>);
                            })
                        }
                    </p>
                    <p className='marketCardText'>
                        Available sizes: {
                            sizes.map((size) => {
                                return(<span id='displaySizes'>
                                            {size} 
                                       </span>);
                            })
                        }
                    </p>
                </CardText>
            </CardBody>
            <CardFooter>
                <Button color='info' style={{ fontWeight: 'bold'}} onClick={subItem} >
                    -
                </Button>
                <span className='mx-5'>{itemQuantity}</span>
                <Button color='info' style={{ fontWeight: 'bold'}} onClick={addItem}>
                    +
                </Button>
            </CardFooter>
        </Card>
    );
};

export default AnimatedMarketItemCard;